import { Col, message, Row } from "antd";
import Axios from "axios";
import React, { Component } from "react";
import QrReader from "react-qr-reader";
import { connect } from "react-redux";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import qr from "../../../static/qr.png";
import "./custom.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedCustomGamer extends Component {
  state = {
    delay: 1000,
    result: "No result",
    gamers: {},
    name: "",
    activeKey: "",
    errorQRs: [],
    qr: "",
  };

  typingTimeout = null;

  inputRef = React.createRef();

  handleChange = () => {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      const value = this.inputRef.current.value
        .replaceAll("É", ":")
        .replaceAll("-", "/")
        .replaceAll("_", "?")
        .replaceAll("ó", "=")
        .replaceAll("z", "#")
        .replaceAll("Z", "@")
        .replaceAll("y", "z")
        .replaceAll("Y", "Z")
        .replaceAll("#", "y")
        .replaceAll("@", "Y")
        .replaceAll("ö", "0");
      this.handleScan(value);
    }, 500);
  };

  componentDidMount() {
    this.inputRef.current.focus();

    this.props.closeKeyboard();
    setInterval(() => {
      this.setState({ errorQRs: [] });
    }, 3000);

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
  }

  handleScan = async (data) => {
    console.log(data);
    if (data !== null) {
      const link = data;
      try {
        const url = new URL(link);
        const qr = url.searchParams.get("qr");
        console.log(qr);
        await Axios.get("/1.0.0/game/check", { params: { qr: qr } })
          .then((response) => {
            if (response.data.exists === true) {
              if (!this.state.errorQRs.includes(qr)) {
                message.error(
                  "A megadott játékos már szerepel más csapatnál!",
                  4
                );
                this.setState({ errorQRs: [...this.state.errorQRs, qr] });
              }
            } else {
              const gamers = {
                qr: qr,
                name: this.props.name,
                email: this.props.email,
              };
              this.setState({ gamers: gamers, qr: qr });
              message.success("Sikeres beolvasás!", 4);

              this.handleNext();
            }
          })
          .catch((err) => {
            console.log(err);
            message.error(
              "Hiba az ellenőrzés során kérem szennelje be újra a kódot!",
              5
            );
          });
      } catch (err) {
        console.log(err);
        message.error("Hibás QR kód!", 3);
      }
    }
  };

  // https://app.appentum.pro/azaumapp?qr=8PzLWzmhoAQ4G8g
  handleError = (err) => {
    console.error(err);
  };

  handleNext = async () => {
    await Axios.post("/1.0.0/game/single-gamer", {
      name: this.props.name,
      email: this.props.email,
      qr: this.state.qr,
      //teamId: null,
    });
    this.props.next();
    //this.props.history.push("/");
  };

  render() {
    return (
      <div>
        <Row>
          <Col span={6} style={{ padding: "1.5em" }}>
            <div>Játékos neve: {this.props.name}</div>
            <div>Játékos e-mail címe: {this.props.email}</div>
            <div>Játékos azonosítója: {this.state.qr}</div>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1.5em",
            }}
          >
            {/* <QrReader
              delay={this.state.delay}
              style={{
                height: 7,
                width: 420,
              }}
              onError={this.handleError}
              onScan={this.handleScan}
            />  */}

            <img alt="QR" src={qr} className="custom-qr-image" />

            <input
              type="text"
              style={{ width: 0, opacity: 0 }}
              ref={this.inputRef}
              autocomplete="off"
              onChange={this.handleChange}
            ></input>
          </Col>
        </Row>
        <div>
          <button
            className="custom-next-button"
            style={{ position: "fixed", bottom: "5%", right: "5%" }}
            onClick={this.handleNext}
            disabled={this.state.qr === ""}
          >
            Következő <Right className="custom-arrow-icon" />
          </button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const CustomGamer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedCustomGamer);
export default CustomGamer;
